export const submitConfigureAccount = context => (id, node) => ({
    type: "JOINT.ACCOUNT.CONFIGURE",
    payload: {id, node},
    context
});